function equalizeHeights(selector) {
  const elements = document.querySelectorAll(selector);
  if (elements.length === 0) return;
  
  requestAnimationFrame(() => {
    elements.forEach(el => el.style.height = 'auto');
    
    requestAnimationFrame(() => {
      let maxHeight = 0;
      elements.forEach(el => {
        const rect = el.getBoundingClientRect();
        const height = rect.height;
        if (height > maxHeight) maxHeight = height;
      });
      
      requestAnimationFrame(() => {
        elements.forEach(el => {
          el.style.height = `${maxHeight}px`;
        });
      });
    });
  });
}

function debounceRAF(func, wait) {
  let timeout = null;
  let rafId = null;
  
  return function executedFunction(...args) {
    const later = () => {
      timeout = null;
      if (rafId !== null) {
        cancelAnimationFrame(rafId);
      }
      rafId = requestAnimationFrame(() => func.apply(this, args));
    };
    
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}

// 检测父元素是否为 display: block 或显示状态
function isParentDisplayed(parentSelector) {
  const parent = document.querySelector(parentSelector);
  if (!parent) return false;
  
  // 检查 computed style
  const style = window.getComputedStyle(parent);
  const display = style.display;
  
  // 检查是否为显示状态
  const isVisible = display !== 'none' && parent.offsetParent !== null && style.visibility !== 'hidden';
  
  return isVisible;
}

// 主函数
function init() {
  const childSelector = '.counponlist-container .image';
  const parentSelector = '.account-coupon-list';
  
  const debouncedEqualize = debounceRAF(() => {
    // 只在父元素显示时执行
    if (isParentDisplayed(parentSelector)) {
      equalizeHeights(childSelector);
    }
  }, 100);
  
  // 初始执行
  debouncedEqualize();
  
  // 监听resize
  window.addEventListener('resize', debouncedEqualize);
  
  // 监听父元素属性变化
  const parent = document.querySelector(parentSelector);
  if (parent) {
    const observer = new MutationObserver(() => {
      // 检查显示状态，如果变为显示则执行
      if (isParentDisplayed(parentSelector)) {
        setTimeout(() => {
          debouncedEqualize();
        }, 100);
      }
    });
    
    observer.observe(parent, {
      attributes: true,
      attributeFilter: ['style', 'class']
    });
    
    // 也检查祖先元素
    let current = parent.parentElement;
    while (current) {
      observer.observe(current, {
        attributes: true,
        attributeFilter: ['style', 'class']
      });
      current = current.parentElement;
    }
  }
}

// 启动
document.addEventListener('DOMContentLoaded', init);